import { render, staticRenderFns } from "./ApproveCinformationModel.vue?vue&type=template&id=6a9b67e4&scoped=true"
import script from "./ApproveCinformationModel.vue?vue&type=script&lang=js"
export * from "./ApproveCinformationModel.vue?vue&type=script&lang=js"
import style0 from "./ApproveCinformationModel.vue?vue&type=style&index=0&id=6a9b67e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9b67e4",
  null
  
)

export default component.exports